import { useEffect, useRef } from "react";
import type { ColorSearchSettings } from "../models/colors";

/**
 * Custom hook to synchronize external view visibility state
 * Keeps the app config in sync with the settings state
 * @param settings - The application settings
 * @param setExternalViewVisible - Function to update external view visibility in app config
 */
export const useExternalViewSync = (
  settings: ColorSearchSettings,
  setExternalViewVisible: (visible: boolean) => void,
) => {
  const externalViewVisibleRef = useRef(settings.externalViewVisible);

  useEffect(() => {
    if (externalViewVisibleRef.current !== settings.externalViewVisible) {
      setExternalViewVisible(settings.externalViewVisible);
    }

    externalViewVisibleRef.current = settings.externalViewVisible;
  }, [settings, setExternalViewVisible]);
};
